import { render, staticRenderFns } from "./AppNavigationGroupList.vue?vue&type=template&id=00284738"
import script from "./AppNavigationGroupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavigationGroupList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports